import React, { FC } from 'react';
import { Warning } from './styles';

const WarningIcon: FC = ({ ...rest }) => {
	return <Warning {...rest} />;
};

export default WarningIcon;
